import { jsx as t } from "react/jsx-runtime";
import { Menu as o, MenuOptionGroup as s, useMultiStyleConfig as u, MenuList as i, MenuItem as M, MenuButton as r, MenuGroup as m, MenuDivider as c, MenuItemOption as p } from "@chakra-ui/react";
const a = o, $ = s;
function y(e) {
  const n = u("MenuTheme");
  return /* @__PURE__ */ t(i, { ...n.list, ...e });
}
function T(e) {
  const n = u("MenuTheme");
  return /* @__PURE__ */ t(M, { ...n.item, ...e });
}
function h(e) {
  const n = u("MenuTheme", e);
  return /* @__PURE__ */ t(r, { ...n.button, ...e });
}
function G(e) {
  const n = u("MenuTheme");
  return /* @__PURE__ */ t(m, { ...n.groupTitle, ...e });
}
function I(e) {
  const n = u("MenuTheme");
  return /* @__PURE__ */ t(c, { ...n.divider, ...e });
}
function O(e) {
  const n = u("MenuTheme");
  return /* @__PURE__ */ t(p, { ...n.item, ...e });
}
export {
  a as Menu,
  h as MenuButton,
  I as MenuDivider,
  G as MenuGroup,
  T as MenuItem,
  O as MenuItemOption,
  y as MenuList,
  $ as MenuOptionGroup
};
//# sourceMappingURL=index.es.js.map
